import DOMHelpers from '../utils/dom-helpers';
import { debounce as _debounce } from 'es-toolkit';


export default class{

    constructor( options ) {
        this.defaults = {
        	el: false,
            main: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'list-artists';
		this.el 			= 	this.options.el;
		this.main			=   this.options.main;

        this.dom            =   new DOMHelpers( document );
        this.images         =   [];

		this.init();
    }

    init(){
        this.initImages();
    	this.addEvents( true );
        this.debounceResize( true, true );
	}

    initImages(){
        let imgs = this.dom.qsa( '#image-rollover span', this.el );
        imgs.forEach( el => {
            let i = parseInt( el.getAttribute( 'data-index' ) ),
            wrap = el.querySelector( '.img-wrapper' );

            if ( wrap ){
                if ( parseInt( wrap.getAttribute( 'data-width' ) ) < parseInt( wrap.getAttribute( 'data-height' ) )  ) {
                    el.classList.add( 'vertical-ratio' );
                }
                else{
                    el.classList.add( 'orizontal-ratio' );
                }
            }

            this.images[ i ] = {
                span: el,
                wrap: wrap
            }
        });
        //console.log( this.images );
    }

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.dom.on( this.dom.qsa( 'li a', this.el ), 'mouseenter', this.onChange );
            this.dom.on( this.dom.qsa( 'li a', this.el ), 'mouseleave', this.onChange );
		}
		else{
			this.dom.off( this.dom.qsa( 'li a', this.el ), 'mouseenter', this.onChange );
            this.dom.off( this.dom.qsa( 'li a', this.el ), 'mouseleave', this.onChange );
            this.debounceResize( false );
		}
        
	}

    onChange = ( e ) => {
        let a = e.target,
            i = a.getAttribute( 'data-index' );
        switch( e.type ){
            case 'mouseenter':
                this.images[ i ].span.classList.add( 'active' );
                this.centerImage( i, e );
                break;
            case 'mouseleave':
                this.images[ i ].span.classList.remove( 'active' );
                break;
        }
    }

    centerImage( i, e ){
        //console.log( e );

        let y = e.pageY - this.dom.offset(this.el).top,
            img = this.images[ i ].span,
            imgh = img.getBoundingClientRect().height,
            h    = this.el.getBoundingClientRect().height;

        // desired position, centered respect the hover
        y = y - imgh/2;

        // check the limits, if visible inside the available space
        y = Math.max( 0, y );
        y = Math.min( y, h - imgh)

        img.style.top = y + 'px';
    }

	debounceResize(b, execute=false) {
		if (b) {
			// debounce resize
			this._debResize = _debounce(() => this.onResize(), 17);
			window.addEventListener('resize', this._debResize);
            if ( execute ){
                this.onResize();
            }
			// Listen for orientation changes
			//this._onOrientation = () => this.onOrientationChange();
			//window.addEventListener('orientationchange', this._onOrientation, false);
		}
		else {
			if (this._debResize) {
				this._debResize.cancel && this._debResize.cancel();
				window.removeEventListener('resize', this._debResize);
			}
            /*
			if (this._onOrientation) {
				window.removeEventListener('orientationchange', this._onOrientation, false);
				this._onOrientation = null;
			}
            */
		}
	}

    onResize( ){
        this.sizeImages();
    }

    sizeImages(){
        
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}